module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.394a3b33.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Medium/Rubik-Medium.ttf
// module id = 1303
// module chunks = 49